import { DepositType } from '@boma/client-shared';
import {
  JournalBankEventType,
  JournalCashInEventType,
  JournalType,
} from '../enums/journal-type.enum';
import { LocationUsageType } from '../enums/location-usage-type.enum';

export interface IJournalBankEvent {
  amount?: number | null;
  comment?: string;
  type: DepositType;
  nameOfLocation: string;
  reference: string;
}

export interface IJournalUpdateRequest {
  amount: number | null;
  comment?: string;
  type: JournalType;
  locationId: string;
  nameOfLocation: string;
  reference: string;
  bankEventType: JournalBankEventType;
}
export interface IJournalCashInRequest {
  amount: number;
  comment?: string;
  receivingUserId: string;
  type: JournalCashInEventType;
}

// startDate: string;
// endDate: string;
// types: number[];
// definitions: {
//   targets: 1;
//   definitionIds: string[];
// };
// locationIds: string[];
// userIds: string[];
// deletedEntries: boolean | false;
export interface IJournalListRequest {
  startDate?: string;
  endDate?: string;
  types?: any[]; // TODO REPLACE WITH ENUM ONCE I KNOW WHAT THE TYPES ARE JournalType;
  definitions?: {
    targets: number;
    definitionIds: string[];
  };
  locationIds?: string[];
  userIds?: string[];
  deletedEntries?: boolean | false;
}

export interface IJournalListResponse {
  id: string;
  locationId: string;
  location: {
    id: string;
    countryId: string;
    address: {
      id: string;
      line1: string;
      line2: string;
      line3: string;
      line4: string;
      town: string;
      province: string;
      postalCode: string;
    };
    countryName: string;
    isEntireCountry: boolean;
    isHeadOffice: boolean;
    name: string;
    usageType: LocationUsageType;
    point: {
      type: string;
      coordinates: number[];
    };
  };
  eventType: string;
  bankEventType: DepositType;
  userId: string;
  user: {
    id: string;
    firstName: string;
    surname: string;
  };
  verifiedAt?: string;
  verifiedById?: string;
  verifiedBy?: {
    id: string;
    firstName: string;
    surname: string;
    idNumber?: string;
    occupation?: string;
    gender?: string;
    dateOfBirth?: string;
  };
  amount: number;
  comment: string;
  deletedAt: string;
  createdAt: string;
  updatedAt: string;
  nameOfLocation: string;
  reference: string;
}

export interface IJournalPaginatedResponse {
  items: IJournalListResponse[];
}

export interface IJournalStatusRequest {
  locationIds: string[];
  userIds: string[];
  registerStatus: string[];
  query: string;
}

export interface IJournalStatusResponse {
  user: {
    id: string;
    firstName: string;
    surname: string;
  };
  location: {
    id: string;
    name: string;
    type: string;
  };
  journalStatus: {
    previousStatusValue: number;
    status: string;
    totalSaleValue: number;
    totalSales: number;
  };
}

export interface IJournalStatusPaginatedResponse {
  items: IJournalStatusResponse[];
}

export interface IJournalDepositListRequest {
  startDate?: string;
  endDate?: string;
  types?: number[]; // JournalType enum replace?
  definitions?: {
    targets: number;
    definitionIds: string[];
  };
  locationIds?: string[];
  userIds?: string[];
  deletedEntries?: boolean | false;
}
